import { Typography } from '@surveycake/rc';
import React, { FC, ReactNode } from 'react';
import Image from '../Image';
import { useStyles } from './styles';

export interface InfoContainerProps {
  image: string;
  title: string;
  info?: ReactNode;
}

const InfoContainer: FC<InfoContainerProps> = ({
  image,
  title,
  info,
  children
}) => {
  const styles = useStyles();

  return (
    <div className={styles.infoContainer} aria-label="info container">
      <div className={styles.wrapper}>
        <div className={styles.main}>
          <header className={styles.header}>
            <Image src={image} />
          </header>
          <Typography variant="h2" color="primary" gutterBottom>
            {title}
          </Typography>
          {info && (
            <Typography variant="p" color="text.B4" gutterBottom>
              {info}
            </Typography>
          )}
          {children && <footer className={styles.footer}>{children}</footer>}
        </div>
      </div>
    </div>
  );
};

export default InfoContainer;
